
import { search as quotings } from './quotings-config'

const inputs = quotings.inputs.slice(3, 6)

export const search = {
  inputs,
  lines: []
}

export default { search }
